/**
 * Created by ajoyal on 6/10/16.
 */

(function (window, $j) {

    function onDocReady() {
        $j(".mw-hero .right-arrow").click(nextImage);
        $j(".mw-hero .left-arrow").click(prevImage);

        $j(".mw-hero .item-container .gallery-thumbs .item").click(changeImage);

        $j(window).resize(checkGalleryNav);
        checkGalleryNav();
    }

    function checkGalleryNav() {
        if($j(window).width() < $j(".mw-hero .overlay-bottom .item-container").width())
            $j(".mw-hero .gallery-nav-container").addClass("show");

        var off = parseInt($j(".mw-hero .item-container").css("left"));
        if(off + $j(".mw-hero .item-container").width() < $j(window).width())
            $j(".mw-hero .item-container")[0].style.left = -($j(".mw-hero .item-container").width() - $j(window).width()) + "px";
    }

    function nextImage() {
        var off = parseInt($j(".mw-hero .item-container").css("left"));
        if(-off + $j(window).width() + 177 < $j(".mw-hero .item-container").width()) {
            $j(".mw-hero .item-container")[0].style.left = (off - 177) + "px";
        }
        else {
            $j(".mw-hero .item-container")[0].style.left = -($j(".mw-hero .item-container").width() - $j(window).width()) + "px";
        }
    }

    function prevImage() {
        var off = parseInt($j(".mw-hero .item-container").css("left"));
        if(off + 177 < 0) {
            $j(".mw-hero .item-container")[0].style.left = (off + 177) + "px";
        }
        else {
            $j(".mw-hero .item-container")[0].style.left = "0px";
        }
    }

    function changeImage() {
        $j(".mw-hero .item-container .gallery-thumbs .item").removeClass("active");
        $j(this).addClass("active");
        $j(".mw-hero .gallery-container .image-slide").removeClass("active");
        $j(".mw-hero .gallery-container .image-slide").eq($j(".mw-hero .item-container .gallery-thumbs .item.active").index()).addClass("active");
    }

    $j(onDocReady);

    return {};

})(window,$j);